import React, { Fragment, useCallback, useContext, useEffect, useRef, useState } from 'react';

import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";

import { BaseButton, Button, DefaultButton, Dialog, DialogFooter, DialogType, Icon, PrimaryButton, ProgressIndicator, Shimmer } from "office-ui-fabric-react";

import JSZip from 'jszip';

import moment from 'moment-timezone';



// import logoImage from '../../../images/three-sixty-image/AvanadeLogo.png';

// import { threeSixtyData } from "../components/360Wheel/ThreeSixtyDataCopilot";



import * as http from '../../../http';





// import { Ws360Wheel } from "../components/360Wheel/360Wheel";
// import { WsWheelItem, WsWheelRecharts } from "./WheelRecharts";



import { WsPortalContext } from "../../PortalContext";
import { WsAppContext } from "../../AppContext";

import { getPermissionLevel } from "../../../helpers-roles";
import { Loading } from "../../Shared";
import { getOrganizationName, getOrganizationType, WsSalesOrganizationType } from "../../../enums";
import { WsTimestamp } from "../../DateTime/Timestamp";
import { getGlobalRegionNameFromSolution } from "../../../core-solution/countries";







import { WsSalesSolutionView } from "../../Sales/Solution/SolutionView";
import { WsSalesSolutionItem } from "../../../core";
import { salesOfferingsTransformData } from "../../../core/sales-process";


import { apiGet, apiPost } from "../../../helpers-sales";
import { wait } from "../../../helpers";
import { WsSalesTimeline2 } from "../../Sales/Solution/SalesTimeline2";
import { WsSalesSolutionPeople } from "../../Sales/Solution/SalesPeople";
import { WsSalesSolutionDeliverablesAndWorkProductsList } from "../../Sales/Solution/SolutionTable";









import '../../Sales/Home.scss';

import './Page.scss';

import './AidaPage.scss';









const steps = {
  1:   '1. Info',
  2:   '2. Scope',
  2.5: '2. Metrics',
  3:   '3. Size',
  4:   '4. ROM',
  5:   '5. Detail',
  6:   '6. Review',
  7:   '7. Close',
  8:   '8. Deliver'
};

const topLevelItemNames: string[] = [
  'Governance',
  'Modern Workplace',
  'Security',
  'Applications and Infrastructure',
  'Data and AI',
  'Business Applications',
  'Customer Experience'
];













const isActive = (pathname: string, path: string, startsWith?: boolean) => {
  if (startsWith) {
    return pathname.toLowerCase().indexOf(path) === 0;
  } else {
    return pathname === path;
  }
};


const WsSolutionMenu = (props: { solutionId: any, solutionItem: any, solutionState: any, loadSalesProcesses?: () => Promise<void> }) => {

  const history = useHistory();
  
  const currentLocation = useLocation();

  return (
    <div className="ws-deliver-page-menu">
      <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}`,               false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}`)               }}>Summary</a>
      <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}/scope`,         false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}/scope`)         }}>Scope</a>
      {/* <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}/core-metrics`, false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}/core-metrics`)  }}>Core Metrics</a> */}
      <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}/timeline`,      false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}/timeline`)      }}>Timeline</a>
      <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}/people`,        false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}/people`)        }}>People</a>
      <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}/deliverables`,  false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}/deliverables`)  }}>Deliverables</a>
      <a className={ isActive(currentLocation.pathname, `/deliver/aida/${props.solutionId}/work-products`, false) ? 'ws-deliver-page-menu-item is-active' : 'ws-deliver-page-menu-item' } onClick={() => { history.push(`/deliver/aida/${props.solutionId}/work-products`) }}>Work Products</a>
      {
        props.loadSalesProcesses
        &&
        <>
          <a
            className={ 'ws-deliver-page-menu-item ws-deliver-page-menu-item-solution-import' }
            onClick={async () => {

              history.push('/deliver/aida/import/run');

              const solutionData: { [ key: string ]: any } = {};

              solutionData['salesClient'] = props.solutionItem.client;

              solutionData['expectedStart'] = props.solutionItem.expectedStart;

              solutionData['requirementDescription'] = props.solutionItem.requirementDescription;

              solutionData['fields'] = props.solutionItem.fields;

              solutionData['state'] = props.solutionState;

              const createSalesSolutionResult = await apiPost('/sales/solutions', solutionData);

              console.log(createSalesSolutionResult);

              await wait(3000);

              props.loadSalesProcesses && props.loadSalesProcesses();

              history.push('/deliver/aida');
            }}
          >Create Project</a>
        </>
      }
    </div>
  );
};





const WsSolutionSummary = (props: { solutionItem: any, solutionState: any }) => {

  return (
    <>
      <table className="ws-deliver-aida-solution-summary">
        <tbody>

          <tr>
            <td>Client:</td>
            <td>{props.solutionItem.client?.name}</td>
            <td></td>
            <td></td>
            <td>Capabilities:</td>
            <td>{props.solutionState.offerings.length}</td>
          </tr>

          <tr>
            <td>Industry:</td>
            <td>{props.solutionItem.client?.fields?.industry}</td>
            <td></td>
            <td></td>
            <td>Actions:</td>
            <td>{props.solutionState.actions.length}</td>
          </tr>

          <tr>
            <td>Opportunity Name:</td>
            <td>{props.solutionItem.fields?.name}</td>
            <td></td>
            <td></td>
            <td>Metrics:</td>
            <td>{props.solutionState.metrics.length}</td>
          </tr>

          <tr>
            <td>Description of Requirements:</td>
            <td></td>
            <td></td>
            <td></td>
            <td>Deliverables:</td>
            <td>{props.solutionState.deliverables.length}</td>
          </tr>

          <tr>
            <td>Complexity:</td>
            <td>{props.solutionItem.fields?.complexity}</td>
            <td></td>
            <td></td>
            <td>Work Products:</td>
            <td>{props.solutionState.workProducts.length}</td>
          </tr>

          <tr>
            <td>Avanade Sales Person:</td>
            <td>{props.solutionItem.fields?.roles.find((item) => item.id === 'SALES_PERSON')?.user?.name}</td>
            <td></td>
            <td></td>
            <td>Roles:</td>
            <td>{props.solutionState.roles.length}</td>
          </tr>

          <tr>
            <td>Avanade Solution Architect:</td>
            <td>{props.solutionItem.fields?.roles.find((item) => item.id === 'SOLUTION_ARCHITECT')?.user?.name}</td>
            <td></td>
            <td></td>
            <td>Tools/Assets:</td>
            <td>{props.solutionState.tools.length}</td>
          </tr>

          <tr>
            <td>Geographic Region:</td>
            <td>{props.solutionItem.fields?.regionId}</td>
            <td></td>
            <td></td>
            <td>Documents:</td>
            <td>{props.solutionItem.documents?.length || 0}</td>
          </tr>

        </tbody>
      </table>
    </>
  );
};














type WsSolutionContentProps = {
  items:    WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;
};

const WsSolutionScope = (props: WsSolutionContentProps) => {

  return (
    <>
      <div style={{ marginTop: 12 }}>
        <WsSalesSolutionView
          items={props.items}
          setItems={props.setItems}
          mode={'proposal'}
          avanade={true}
        />
      </div>
    </>
  );
};








const WsSalesProcess = (props: { salesProcesses: any[] }) => {

  const currentParams: { solutionId: string } = useParams();

  const [ items, setItems ] = useState<WsSalesSolutionItem[]>([]);

  // const [ state, setState ] = useState<{ [ key: string ]: any } | undefined>(undefined);



  const salesProcess = props.salesProcesses.find((item) => item.id === Number(currentParams.solutionId));



  useEffect(() => {

    const solutionItems = salesOfferingsTransformData(salesProcess.state, {});

    console.log(solutionItems);

    setItems(solutionItems);

  }, []);



  if (salesProcess) {

    console.log(salesProcess);

    return (
      <div style={{ paddingTop: 10 }}>
        <WsSolutionMenu
          solutionId={salesProcess.id}
          solutionItem={salesProcess}
          solutionState={salesProcess.state}
        />
        <Switch>
          <Route path={`/deliver/aida/${currentParams.solutionId}/scope`}>
            <WsSolutionScope
              items={items}
              setItems={setItems}
            />
          </Route>

          <Route path={`/deliver/aida/${currentParams.solutionId}/timeline`}>
            <WsSalesTimeline2
              startDate={moment(`${salesProcess.expectedStart}-01T00:00:00Z`).toDate()}
              items={items}
              screenshot={false}
              avanade={true}
            />
          </Route>

          <Route path={`/deliver/aida/${currentParams.solutionId}/people`}>
            <br />
            <WsSalesSolutionPeople
              items={items}
              startDate={moment(`${salesProcess.expectedStart}-01T00:00:00Z`).tz('UTC').toDate()}
            />
          </Route>

          <Route path={`/deliver/aida/${currentParams.solutionId}/deliverables`}>
            <WsSalesSolutionDeliverablesAndWorkProductsList title="Deliverables" avanade={true} decode={true} />
          </Route>

          <Route path={`/deliver/aida/${currentParams.solutionId}/work-products`}>
            <WsSalesSolutionDeliverablesAndWorkProductsList title="Work Products" avanade={true} decode={true} />
          </Route>

          <Route path={`/deliver/aida/${currentParams.solutionId}`}>
            <WsSolutionSummary
              solutionItem={salesProcess}
              solutionState={salesProcess.state}
            />
          </Route>
        </Switch>
      </div>
    );
  } else {
    return (
      <>
        <br />
        <br />
        <div className="notification is-warning">Solution not found!</div>
      </>
    );
  }
};












const WsSolutionPreview = (props: { loadSalesProcesses: () => Promise<void>, jsonEntries: WsZipFile[] }) => {

  const [ items, setItems ] = useState<WsSalesSolutionItem[]>([]);

  const [ state, setState ] = useState<{ [ key: string ]: any } | undefined>(undefined);



  useEffect(() => {

    console.log(props.jsonEntries);

    const solutionState: { [ key: string ]: any } = {
      '$version': '3.0'
    };

    solutionState['offerings']    = getDataFromJson(props.jsonEntries, 'capabilities');

    solutionState['actions']      = getDataFromJson(props.jsonEntries, 'actions');

    solutionState['metrics']      = getDataFromJson(props.jsonEntries, 'metrics');

    solutionState['deliverables'] = getDataFromJson(props.jsonEntries, 'deliverables');

    solutionState['workProducts'] = getDataFromJson(props.jsonEntries, 'work-products');

    solutionState['roles']        = getDataFromJson(props.jsonEntries, 'roles');

    solutionState['tools']        = getDataFromJson(props.jsonEntries, 'tools');

    solutionState['assumptions']  = [];

    solutionState['dependencies'] = [];

    console.log(solutionState);

    const solutionItems = salesOfferingsTransformData(solutionState, {});

    console.log(solutionItems);

    setItems(solutionItems);

    setState(solutionState);

  }, []);



  const solutionItem = props.jsonEntries.find((jsonItem) => jsonItem.filename === 'solution.json');



  if (items && state && solutionItem) {

    // console.log(solutionItem);

    return (
      <>
        <Switch>
          <Route path={`/deliver/aida/import/run`}>
            <Loading />
          </Route>
          <Route path={`/deliver/aida/import`}>
            <WsSolutionMenu
              solutionId={'import'}
              solutionItem={solutionItem.data}
              solutionState={state}
              loadSalesProcesses={props.loadSalesProcesses}
            />
          </Route>
        </Switch>

        <Switch>
          <Route path={`/deliver/aida/import/run`}></Route>

          <Route path={`/deliver/aida/import/scope`}>
            <WsSolutionScope
              items={items}
              setItems={setItems}
            />
          </Route>

          <Route path={`/deliver/aida/import/timeline`}>
            <WsSalesTimeline2
              startDate={moment(`${solutionItem.data.expectedStart}-01T00:00:00Z`).toDate()}
              items={items}
              screenshot={false}
              avanade={true}
            />
          </Route>

          <Route path={`/deliver/aida/import/people`}>
            <br />
            <WsSalesSolutionPeople
              items={items}
              startDate={moment(`${solutionItem.data.expectedStart}-01T00:00:00Z`).tz('UTC').toDate()}
            />
          </Route>

          <Route path={`/deliver/aida/import/deliverables`}>
            <WsSalesSolutionDeliverablesAndWorkProductsList title="Deliverables" avanade={true} decode={true} />
          </Route>

          <Route path={`/deliver/aida/import/work-products`}>
            <WsSalesSolutionDeliverablesAndWorkProductsList title="Work Products" avanade={true} decode={true} />
          </Route>

          <Route path={`/deliver/aida/import`}>
            <WsSolutionSummary
              solutionItem={solutionItem.data}
              solutionState={state}
            />
          </Route>
        </Switch>
      </>
    );

  } else {
    return (
      <>
        FAILED: Solution could not be loaded!
      </>
    );
  }
};














interface FileUploaderProps {
  onFileSelect: (file: File | null) => void;
  accept?: string;
}

const WsFileUploader: React.FC<FileUploaderProps> = ({ onFileSelect, accept = '*' }) => {

  const [isDragging, setIsDragging] = useState(false);
  const [fileName, setFileName] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDrag = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setIsDragging(true);
    } else if (e.type === 'dragleave') {
      setIsDragging(false);
    }
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      setFileName(file.name);
      onFileSelect(file);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (file) {
      setFileName(file.name);
      onFileSelect(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div 
      className={`file-dropzone ${isDragging ? 'dragging' : ''}`}
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      onClick={handleClick}
      style={{
        paddingTop:    20,
        paddingBottom: 50,
        backgroundColor: '#f4f4f4',
        color: '#625555',
        textAlign: 'center',
        cursor: 'pointer'
      }}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleChange}
        accept={accept}
        style={{
          display: 'none'
        }}
      />
      <Icon
        iconName="CloudUpload"
        style={{
          fontSize: 70
        }}
      />
      <div className="dropzone-content">
        {
          fileName
          ?
          <div>{fileName}</div>
          :
          <div>Drop Solution file here or click to browse!</div>
        }
      </div>
    </div>
  );
};







const getDataFromJson = (jsonEntries: WsZipFile[], type: string) => {

  const entry = jsonEntries.find((jsonItem) => jsonItem.filename === `${type}.json`);

  if (entry && entry.data && Array.isArray(entry.data)) {
    return entry.data;
  } else {
    return [];
  }
};




const getProcessingLabel = (percentComplete: number) => {

  if (percentComplete === 1) {
    return '';

  } else if (percentComplete > 0.7) {
    return 'Loading Metrics...';

  } else if (percentComplete > 0.5) {
    return 'Loading Actions...';

  } else if (percentComplete > 0.3) {
    return 'Loading Capabilities...';

  } else {
    return 'Processing Solution Data...'
  }
};

interface WsZipFile {
  filename: string;
  data: any;
}

const ZipFileViewer = (props: { loadSalesProcesses: () => Promise<void> }) => {

  const history = useHistory();
  
  const currentLocation = useLocation();

  const [ jsonEntries, setJsonEntries ] = useState<WsZipFile[]>([]);

  const [ processingSolution, setProcessingSolution ] = useState<boolean>(false);



  const handleFileChange = async (file: any) => {
    // const file = e.target.files[0];
    // if (!file) return;

    try {
      // Create a new JSZip instance
      const zip = new JSZip();
      
      // Load the zip file
      const zipData = await zip.loadAsync(file);

      const jsonObjects: WsZipFile[] = [];

      // Process each file in the zip
      const processEntries = Object.keys(zipData.files).map(async (filename) => {
        const zipEntry = zipData.files[filename];
        
        // Skip directories
        if (zipEntry.dir) return;
        
        // Process only JSON files
        if (filename.endsWith('.json')) {
          try {
            // Get the file content as text
            const content = await zipEntry.async('string');
            
            // Parse the JSON
            const jsonObject = JSON.parse(content);
            
            jsonObjects.push({
              filename: filename,
              data: jsonObject
            });
          } catch (parseError) {
            console.error(`Error parsing JSON in ${filename}:`, parseError);
          }
        }
      });

      // Wait for all entries to be processed
      await Promise.all(processEntries);
      
      // Update state with JSON objects
      setJsonEntries(jsonObjects);
      
    } catch (error) {
      console.error('Error reading zip file:', error);
    }
  };



  const handleFileSelect = (selectedFile: File | null) => {
    // setFile(selectedFile);
    if (selectedFile) {
      console.log('Selected file:', selectedFile.name);
      // Process file here
      handleFileChange(selectedFile);

      setPercentComplete(0);
      setProcessingSolution(true);
    }
  };



  const intervalDelay = process.env.NODE_ENV === 'development' ? 10 : 120;

  const intervalIncrement = 0.035;

  const [ percentComplete, setPercentComplete ] = React.useState(1);



  // console.log(percentComplete);

  const processingLabel = getProcessingLabel(percentComplete);

  // console.log(processingLabel);



  useEffect(() => {

    setTimeout(() => {

      const p = percentComplete + intervalIncrement;

      if (p > 0.99) {
        setPercentComplete(1);
      } else {
        setPercentComplete(p);
      }

    }, intervalDelay);

  }, [ percentComplete ]);



  useEffect(() => {

    if (jsonEntries && Array.isArray(jsonEntries) && jsonEntries.length > 0) {
      // preview solution
    } else {

      if (currentLocation.pathname !== '/deliver/aida/import') {
        history.push('/deliver/aida/import');
      }
    }

  }, [ jsonEntries ]);



  return (
    <div>
      {/* <h2>JSON Entries Viewer</h2>
      <input type="file" accept=".solution" onChange={handleFileChange} />
      {jsonEntries.length > 0 &&
        jsonEntries.map((entry, index) => (
          <div key={index}>
            <h3>{entry.filename}</h3>
            <pre>{JSON.stringify(entry.data, null, 2)}</pre>
          </div>
        ))
      } */}
      <div style={{ width: '100%', marginTop: 20 }}>
        {/* <h2>File Upload</h2> */}

        <WsFileUploader 
          onFileSelect={handleFileSelect}
          accept=".solution"
          // accept="image/*,application/pdf"
        />

        {
          processingSolution
          &&
          <div style={{ marginTop: -8 }}>
            <ProgressIndicator
              // label="Solution Import"
              description={processingLabel}
              percentComplete={percentComplete}
              barHeight={4}
            />
          </div>
        }

        {
          percentComplete === 1
          &&
          jsonEntries
          &&
          Array.isArray(jsonEntries)
          &&
          jsonEntries.length > 0
          &&
          // process.env.NODE_ENV === 'development'
          // &&
          <WsSolutionPreview
            loadSalesProcesses={props.loadSalesProcesses}
            jsonEntries={jsonEntries}
          />
        }

        {/* {file && (
          <p style={{ marginTop: '10px' }}>
            Ready to upload: {file.name} ({(file.size / 1024).toFixed(1)} KB)
          </p>
        )} */}
      </div>
    </div>
  );
};





const WsAidaPage = (props: {}) => {

  const appContext = useContext(WsAppContext);

  const portalContext = useContext(WsPortalContext);

  const history = useHistory();

  const currentLocation = useLocation();

  const [ salesProcesses, setSalesProcesses ] = useState<any[] | undefined>(undefined);

  const loadSalesProcesses = useCallback(async () => {

    setSalesProcesses(undefined);

    const currentUserResult = await http.get<any>('/v2/users/current');

    if (currentUserResult && currentUserResult.currentUser) {

      const salesSolutionsResult = await apiGet('/sales/solutions');

      if (salesSolutionsResult && salesSolutionsResult.salesSolutions && Array.isArray(salesSolutionsResult.salesSolutions)) {

        const permissionLevel = getPermissionLevel('sales/solutions', appContext?.role);

        setSalesProcesses(
          salesSolutionsResult.salesSolutions
          // .filter((salesProcess: any) => {
          //   return salesProcess.fields?.isExportedToDeliver;
          // })
          .sort((a: any, b: any) => {
            if (a.modifiedAt < b.modifiedAt) return 1;
            if (a.modifiedAt > b.modifiedAt) return -1;
            return 0;
          })
        );
      }
    }

  }, []);

  useEffect(() => {

    loadSalesProcesses();

  }, [ appContext?.role, portalContext?.currentUser?.id ]);


 
  return (
    <div className="ws-deliver-page ws-deliver-aida-page ws-sales-solution ws-sales-solution-list">

      <div className="ws-deliver-page-header">

        <div className="tabs is-medium is-boxed">
          <ul>
            <li className="ws-deliver-aida-page-title">
              <h1>
                AIDA
              </h1>
            </li>
            <li className={ currentLocation.pathname !== '/deliver/aida/import' ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/aida')               }}>Solutions</a></li>
            <li className={ currentLocation.pathname === '/deliver/aida/import' ? 'is-active' : '' }><a onClick={() => { history.push('/deliver/aida/import')        }}>Import</a></li>
          </ul>
        </div>

      </div>

      <div>
        <Switch>
          <Route path={`/deliver/aida/import`}>
            <ZipFileViewer loadSalesProcesses={loadSalesProcesses} />
            <br />
            <br />
            <br />
          </Route>
          <Route path={`/deliver/aida/:solutionId`}>
            {
              salesProcesses
              ?
              <WsSalesProcess salesProcesses={salesProcesses} />
              :
              <div style={{ textAlign: 'center' }}>
                <br />
                <br />
                <Loading />
                <br />
                <br />
                <br />
              </div>
            }
          </Route>
          <Route path={`/deliver/aida`}>
            {
              salesProcesses
              ?
              <>
                {
                  salesProcesses.length > 0
                  ?
                  <>
                    <br />
                    <table className="table is-hoverable">
                      <thead>
                        <tr>
                          <th>Opportunity</th>
                          <th>Client Name</th>
                          <th>Country</th>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th>Updated</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          salesProcesses.map((salesProcess, index) => {

                            const organization = getOrganizationType(salesProcess.fields.organization);

                            return (
                              <tr key={`ws-capability-${index}`}>
                                <td>
                                  <NavLink to={`/deliver/aida/${salesProcess.id}`}>{ salesProcess.fields['name'] ? salesProcess.fields['name'] : 'Draft' }</NavLink>
                                  {/* { [ WsSalesOrganizationType.HP, WsSalesOrganizationType.Accenture ].includes(organization) ? ` (${getOrganizationName(organization)})` : '' } */}
                                </td>
                                <td>{salesProcess.clientName}</td>

                                <td>
                                  {
                                    getGlobalRegionNameFromSolution(salesProcess)
                                  }
                                </td>

                                <td></td>

                                <td></td>

                                <td></td>

                                <td>
                                  <WsTimestamp timestamp={salesProcess.modifiedAt} />
                                </td>
                              </tr>
                            );
                          })
                        }
                      </tbody>
                    </table>
                  </>
                  :
                  <>
                    <br />
                    <br />
                    <div className="notification is-warning">There are no solutions created yet!</div>
                  </>
                }
              </>
              :
              <div style={{ textAlign: 'center' }}>
                <br />
                <br />
                <Loading />
                <br />
                <br />
                <br />
              </div>
            }
          </Route>
        </Switch>
      </div>
    </div>
  );
};




export {
  WsAidaPage
};
